"use client";
import { useState, useEffect } from "react";
import { cn } from "../lib/utils";
import Loading from "./loading";

const LoadingDocument = () => {
  const [loaded, setLoaded] = useState(false);
  const handleLoad = () => setLoaded(true);
  const bgLayerStyles = cn(
    loaded ? "h-0" : "h-full",
    "fixed bottom-0 w-full overflow-hidden z-[999]",
    "loading-layer-transition",
  );

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 1000);
    // window.addEventListener("load", handleLoad);
    // return () => window.removeEventListener("load", handleLoad);
  }, []);

  return (
    <div className={cn(bgLayerStyles, "!delay-100 bg-violet-600")}>
      <div
        className={cn(
          bgLayerStyles,
          "bg-zinc-950 flex items-center justify-center",
        )}>
      </div>
    </div>
  );
};

export default LoadingDocument;
